import React from 'react'

import { triggersClient } from '../../../utils/apollo/api'
import { gql, useQuery } from '@apollo/client'

const Context = React.createContext()
const { Provider } = Context

export const useTriggerCallsCountState = () => React.useContext(Context) || {}
export const useTriggerCallsCount = () => useTriggerCallsCountState()?.triggerCallsCount

const QUERY = gql`
  query TriggerCallsCount($filter: TriggerCallFilter) {
    triggerCallsCount(filter: $filter)
  }
`

const TriggerCallsCountLoader = ({ children, entity, id, entityType, status }) => {
  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        entityType: entityType,
        status: status,
        data: JSON.stringify({ record: { [entity]: { id } } })
      }
    },
    client: triggersClient
  })

  return <Provider value={data}>{children}</Provider>
}

export default TriggerCallsCountLoader
